// extracted by mini-css-extract-plugin
export default {"container":"BusinessCard_container__ofmby","addCardBtn":"BusinessCard_addCardBtn__EvM4e"};